export default __webpack_public_path__ + "static/outrageous-things-infographic-c6592f9df81f4f4461f6fc51b558ee2c.jpg";